import { TutorialTile } from "../../../../shared/tutorial-tiles/model";

import TutorialAnimation from '../../../../shared/tutorial-tiles/components/animations/Filters';

export const TUTORIAL_TILE_KEY = 'builder-catalog-filter';

export const tutorialTileConfig: TutorialTile = {
  titleI18nKey: 'tutorialTiles:builder:catalog:filters:title',
  image: TutorialAnimation,
  items: [
    {
      descriptionI18nKey: 'tutorialTiles:builder:catalog:filters:items:filterYourData:description',
      icon: 'Filter',
      titleI18nKey: 'tutorialTiles:builder:catalog:filters:items:filterYourData:title',
    },
    {
      descriptionI18nKey: 'tutorialTiles:builder:catalog:filters:items:pickValues:description',
      icon: 'CheckListText',
      titleI18nKey: 'tutorialTiles:builder:catalog:filters:items:pickValues:title',
    },
    {
      descriptionI18nKey: 'tutorialTiles:builder:catalog:filters:items:createRules:description',
      icon: 'FlowChart',
      titleI18nKey: 'tutorialTiles:builder:catalog:filters:items:createRules:title',
    },
  ],
  showMeUrl: 'https://eyko.zendesk.com/hc/en-us/articles/1500010411241-Builder-Filters-Reduce-the-clutter',
};
